import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dialog-view-toggle"
export default class extends Controller {
  static targets = [
    "toggleButton",
    "buttonText",
    "wrapper",
    "list",
    "dialog",
    "dialogContainer",
    "settings"
  ]

  defaultView = true

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('dialog_id') || urlParams.has('chat_id')) {
      this.showButton()
    }
  }

  showButton() {
    this.toggleButtonTarget.classList.remove("hidden!")
  }

  toggle() {
    this.defaultView = !this.defaultView

    this.wrapperTarget.classList.toggle("min-h-800")
    this.wrapperTarget.classList.toggle("max-w-1285")
    this.wrapperTarget.classList.toggle("mx-auto")
    this.wrapperTarget.classList.toggle("pr-65")
    this.wrapperTarget.classList.toggle("3xl:pr-0")
    this.listTarget.classList.toggle("hidden")
    this.dialogTarget.classList.toggle("col-span-7")
    this.dialogTarget.classList.toggle("col-span-5")
    this.dialogContainerTarget.classList.toggle("col-span-3")
    this.dialogContainerTarget.classList.toggle("col-span-7")
    this.settingsTargets.forEach(target => target.classList.toggle("hidden"))

    this.buttonTextTarget.innerHTML = this.defaultView
      ? "Full screen view"
      : "Default view"
  }
}
